import { createSlice } from "@reduxjs/toolkit";
import { fetchRewardsItems } from "./RewardsThunks";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const rewardsSlice = createSlice({
  name: "rewards",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchRewardsItems.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRewardsItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchRewardsItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default rewardsSlice.reducer;